import { find } from 'lodash/fp';

import constants from '../../../../../../../ahm-constants';
import getIncomeTierOptions from '../../../../../../../utils/get-income-tier-options';

// @ts-expect-error - Automatic, Please fix when editing this file
const getDataForTier = (incomeTier, tiers) => find({ value: incomeTier })(tiers);

const getScaleTableData = (forceDate = null) => {
  const singlesTiers = getIncomeTierOptions({ forceDate, incomeType: constants.INCOME_TYPE.SINGLE, isCompact: true });
  const couplesTiers = getIncomeTierOptions({ forceDate, incomeType: constants.INCOME_TYPE.COUPLE, isCompact: true });
  const singlesTier0 = getDataForTier(constants.INCOME_TIER.TIER_0, singlesTiers);
  const singlesTier1 = getDataForTier(constants.INCOME_TIER.TIER_1, singlesTiers);
  const singlesTier2 = getDataForTier(constants.INCOME_TIER.TIER_2, singlesTiers);
  const singlesTier3 = getDataForTier(constants.INCOME_TIER.TIER_3, singlesTiers);
  const couplesTier0 = getDataForTier(constants.INCOME_TIER.TIER_0, couplesTiers);
  const couplesTier1 = getDataForTier(constants.INCOME_TIER.TIER_1, couplesTiers);
  const couplesTier2 = getDataForTier(constants.INCOME_TIER.TIER_2, couplesTiers);
  const couplesTier3 = getDataForTier(constants.INCOME_TIER.TIER_3, couplesTiers);
  return [
    {
      // @ts-expect-error - Automatic, Please fix when editing this file
      couplesFamilies: `${couplesTier0.text}`,
      // @ts-expect-error - Automatic, Please fix when editing this file
      mls: singlesTier0.rate,
      // @ts-expect-error - Automatic, Please fix when editing this file
      singles: singlesTier0.text,
    },
    {
      // @ts-expect-error - Automatic, Please fix when editing this file
      couplesFamilies: couplesTier1.text,
      // @ts-expect-error - Automatic, Please fix when editing this file
      mls: singlesTier1.rate,
      // @ts-expect-error - Automatic, Please fix when editing this file
      singles: singlesTier1.text,
    },
    {
      // @ts-expect-error - Automatic, Please fix when editing this file
      couplesFamilies: couplesTier2.text,
      // @ts-expect-error - Automatic, Please fix when editing this file
      mls: singlesTier2.rate,
      // @ts-expect-error - Automatic, Please fix when editing this file
      singles: singlesTier2.text,
    },
    {
      // @ts-expect-error - Automatic, Please fix when editing this file
      couplesFamilies: couplesTier3.text,
      // @ts-expect-error - Automatic, Please fix when editing this file
      mls: singlesTier3.rate,
      // @ts-expect-error - Automatic, Please fix when editing this file
      singles: singlesTier3.text,
    },
  ];
};

export default getScaleTableData;
